import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=1df4d165&"
import script from "./DetailsTable.vue?vue&type=script&lang=js&"
export * from "./DetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports